import StandalonePillBoxMultiSelect from '../../components/Form/StandalonePillBoxMultiSelect'

export type CyclesType = 'OneToEighty' | 'EightyOneToTwoHundred' | 'TwoHundredPlus'

const options: {
  id: string | number
  value: CyclesType
  label: string
  color: 'green' | 'yellow' | 'orange'
}[] = [
  { id: "1-80", value: 'OneToEighty', label: '1-80 cycles', color: 'green' },
  { id: "81-200", value: 'EightyOneToTwoHundred', label: '81-200 cycles', color: 'yellow' },
  { id: "200+", value: 'TwoHundredPlus', label: '200 cycles+', color: 'orange' },
]

export interface CyclesSelectProps {
  value: CyclesType[]
  onChange: (value: CyclesType[]) => void
}

export default function CyclesSelect({
  value,
  onChange,
}: CyclesSelectProps) {
  return (
    <StandalonePillBoxMultiSelect
      placeholder={"Cycles"}
      value={value}
      options={options}
      onChange={onChange}
    />
  )
}
